import { RESET_STATE, SET_WAYS_LIST, SET_IS_WAYS_LIST_LOADING, SET_PAGINATION, SET_TABLE_SEARCH } from './actions';

export const initialState = {
	trailersList: null,
	isWaysListLoading: false,
	pagination: null,
	tableSearch: '',
};

const waysContainerReducer = (state = initialState, action) => {
	const { type, payload } = action;
	switch (type) {
		case SET_WAYS_LIST:
			return {
				...state,
				waysList: payload,
			};
		case SET_IS_WAYS_LIST_LOADING:
			return {
				...state,
				isWaysListLoading: payload,
			};
		case SET_PAGINATION:
			return {
				...state,
				pagination: payload,
			};
		case SET_TABLE_SEARCH:
			return {
				...state,
				tableSearch: payload,
			};
		case RESET_STATE:
			return initialState;
		default:
			return state;
	}
};

export default waysContainerReducer;
